import { defineMessages } from 'react-intl';

export const i18n: {
	error: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rootNotFound: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unsupportedContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	permissionError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	expandAll: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	collapseAll: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	error: {
		id: 'pagetree-macro.renderer.error',
		defaultMessage:
			'There was a problem retrieving the page tree. Please check the server log file for more information.',
		description: 'Error message when the page tree macro fails to render',
	},
	rootNotFound: {
		id: 'pagetree-macro.renderer.root-not-found',
		defaultMessage: 'The selected root page could not be found.',
		description:
			'Error message when the root page specified in the macro parameters cannot be found',
	},
	unsupportedContent: {
		id: 'pagetree-macro.renderer.unsupported-content',
		defaultMessage: 'Page Tree can only be used in pages, blog posts and comments.',
		description: 'Error message when the macro is used in unsupported content',
	},
	permissionError: {
		id: 'pagetree-macro.renderer.permission-error',
		defaultMessage:
			'Unable to load page tree. It seems that you do not have permission to view the root page.',
		description: 'Error message when the user lacks permission to view the root page',
	},
	expandAll: {
		id: 'pagetree-macro.renderer.expand-all',
		defaultMessage: 'Expand all',
		description: 'Button label to expand all nodes in the page tree',
	},
	collapseAll: {
		id: 'pagetree-macro.renderer.collapse-all',
		defaultMessage: 'Collapse all',
		description: 'Button label to collapse all nodes in the page tree',
	},
	searchPlaceholder: {
		id: 'pagetree-macro.renderer.search-placeholder',
		defaultMessage: 'Search page tree',
		description: 'Aria label for the page tree search input',
	},
	searchButton: {
		id: 'pagetree-macro.renderer.search-button',
		defaultMessage: 'Search',
		description: 'Button label for the page tree search submit button',
	},
	loading: {
		id: 'pagetree-macro.renderer.loading',
		defaultMessage: 'Loading...',
		description: 'Text shown while page tree data is loading',
	},
});
